import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { UserService } from './core/user.service';
import { Global } from './core/Global';


@Injectable()

export class ContractInsuredService {
	private url: string = Global.url_seguros;
	private _http = inject(HttpClient)
	private _userService: UserService = inject(UserService)
	private entity = this._userService.sharingEntity();

	

	getPoliciesAvailables(insured: any): Observable<any> {
		let headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this._http.get(this.url + 'contracts/policies/' + insured, {headers: headers})
	}


}
